import { Button, FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme, withStyles
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Edit } from "@material-ui/icons";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { MessageRounded } from "@material-ui/icons";
import TicketCommentsModal from "../SampleStorage/comment";
import {
    createSamplesStorage, getProjects, getProjectSampleAllData, getProjectSampleList, getSampleProjectData, updateSamplesStorage
} from "../../store/actions";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        root1: {
            // backgroundColor: "#fa4d83",

        }
    })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#12145e",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);
interface Props {
    sampleStoragedata: any;
    onBoardingActionType: any;
    projects: any;
    getProjects: any;
    getProjectSampleList: any;
    sapmleList: any;
    sampleAllData: any;
    getProjectSampleAllData: any;
    createSamplesStorage: any;
    getSampleProjectData: any;
    fetchsamplepdata: any;
    updateSamplesStorage: any;
    loading: any;

}
const StopsPlace: React.FC<Props> = ({
    sampleStoragedata,
    onBoardingActionType,
    projects,
    getProjects,
    getProjectSampleList,
    sapmleList,
    sampleAllData,
    getProjectSampleAllData,
    createSamplesStorage,
    getSampleProjectData,
    fetchsamplepdata,
    updateSamplesStorage,
    loading,

}) => {
    const classes = useStyles();
    const history = useHistory();
    const timer = useRef<any>(0);
    const { id } = useParams<{ id: string }>();
    const [freezerNo, setFreezerNo] = useState<any>("");
    const [project, setProject] = useState<any>("");
    const [isEdit, setIsEdit] = useState<any>(false);
    const [rack, setRack] = useState<any>("");
    const [key, setKey] = useState<any>(true);
    const [projectname, setProjectName] = useState<any>("")
    const [handover, sethandover] = useState<any>("")
    const [page, setPage] = useState(0);
    const [freezer, setFreezer] = useState<any>("");
    const [box, setBox] = useState<any>("");
    const [wellId, setWellId] = useState<any>("");
    const [sample, setSample] = useState<any>();
    const [sampleName, setSampleName] = useState<any>();
    const [displaySample, setDisplaySample] = useState<string>("");
    const [comment, setComment] = useState<any>("");
    const [openModal, setopenModal] = useState<boolean>(false);
    const [runData, setRunData] = useState<any>("")


    useEffect(() => {
        getProjects();
    }, [])

    useEffect(() => {
        if (project !== "") {
            getProjectSampleAllData(`?stored=false&project=${project}`);
        }

    }, [project])

    useEffect(() => {
        if (project !== "") {
            getSampleProjectData(`?project=${project}`);

        }

    }, [project])

    let [fetchSampleData, setFetchSampleData] = useState<any>([]);

    const handleClick = (data: any) => {
        setopenModal(true);
        setRunData(data);
    };

    useEffect(() => {
        let storeData: any = [];
        if (fetchsamplepdata && fetchsamplepdata?.results?.length > 0 && project)
            fetchsamplepdata?.results?.filter((data: any) => data?.storage).map((data: any, index: any) => {
                storeData.push({
                    ...data,
                })
            })

        setFetchSampleData(storeData);
    }, [fetchsamplepdata, project])

    const handleAddSequence = async (e: any) => {
        e.preventDefault();
        const sampleStorageData = {
            handoverTo: handover,
            boxId: box,
            wellId: wellId,
            freezerName: freezer,
            freezerNo: freezerNo,
            rackNo: rack,
            comment: comment,

        }
        if (sample && sampleStorageData && isEdit === false) {
            await createSamplesStorage(sample, sampleStorageData);
            getProjectSampleAllData(`?stored=false&project=${project}`);
        } else if (isEdit) {
            await updateSamplesStorage(sample, sampleStorageData);
        }
        getSampleProjectData(`?project=${project}`);
        setIsEdit(false);
        setSample("");
        setDisplaySample("");
        sethandover("");
        setFreezer("");
        setBox("");
        setWellId("");
        setRack("");
        setFreezerNo("");
        setFreezer("");
        setSample("");
        setComment("");

    };
    const handleEdit = (val: any) => {
        setIsEdit(true);
        setSample(val?._id);
        setDisplaySample(val?.name);
        setSample(val?._id)
        setSampleName(val?.name)
        sethandover(val?.storage?.handoverTo);
        setBox(val?.storage?.boxId);
        setWellId(val?.storage?.wellId);
        setRack(val?.storage?.rackNo);
        setFreezerNo(val?.storage?.freezerNo);
        setFreezer(val?.storage?.freezerName);
        setComment(val?.storage?.comment);
        setKey(!key);
    };
    return (
        <Grid container spacing={2}>
            <form onSubmit={handleAddSequence} style={{ width: "100%" }}>
                <Paper style={{ margin: "70px auto", width: "100%", marginTop: 10 }} className={classes.root1}>
                    {isEdit === false ?
                        <h2 style={{ fontWeight: "bold", paddingTop: "20px", paddingBottom: "10px", textAlign: "center" }}>Sample Storage Details</h2>
                        : ""}
                    {isEdit === true ?
                        <h2 style={{ fontWeight: "bold", paddingTop: "20px", paddingBottom: "10px", textAlign: "center" }}>Edit Sample Storage Details</h2>
                        : ""}
                    <Grid container spacing={2} style={{ marginLeft: 1 }}>
                        <Grid item xs={12} sm={4} md={3}>
                            <Autocomplete
                                // key={isEdit}
                                id="Project"
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        setProject(newValue?._id);
                                    } else {
                                        setProject("")
                                    }
                                }}
                                options={projects?.results || []}
                                blurOnSelect
                                getOptionLabel={(option: any) => {
                                    return (
                                        (option?.projectId) +
                                        " " +
                                        (option?.institute?.name || "") +
                                        " " +
                                        (option?.scientist?.name || "") +
                                        "," +
                                        (option?.dealer?.firmName || "")
                                    );
                                }}
                                onInputChange={(event, newInputValue) => {
                                    let data = newInputValue.split(" ");
                                    clearTimeout(timer.current);
                                    timer.current = setTimeout(() => {
                                        if (data.length > 0) {
                                            getProjects(`?projectId=${data[0]}`);
                                        }
                                    }, 1000);
                                    setProjectName(newInputValue);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        className="input"
                                        label="Project"
                                        variant="outlined"
                                        placeholder="Search ID/Client/Dealer Name"
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <Autocomplete
                                // key={isEdit}
                                id="sample_name"
                                onChange={(event, newValue) => {
                                    setSample(newValue?._id);
                                }}
                                options={sampleAllData?.results || []}
                                loading={loading}
                                blurOnSelect
                                getOptionLabel={(option: any) => `${option?.name}`}
                                inputValue={displaySample}
                                onInputChange={(event, newInputValue) => {
                                    setDisplaySample(newInputValue)
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        className="input"
                                        label="Sample Names"
                                        placeholder="Select Sample Name"
                                        variant="outlined"
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3} >
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>Sample Freezer Name*</InputLabel>
                                <Select
                                    label="Sample Freezer Name"
                                    variant="outlined"
                                    className="input"
                                    fullWidth
                                    value={freezer || "none"}
                                    style={{ width: "100%", height: "40px" }}
                                    onChange={(e) => setFreezer(e.target.value)}
                                >
                                    <MenuItem value="none" disabled><em>Select Freezer Name</em></MenuItem>
                                    <MenuItem value="Freezer 4°C">Freezer 4°C</MenuItem>
                                    <MenuItem value="Freezer -20°C">Freezer -20°C</MenuItem>
                                    <MenuItem value="Deep Freezer -80°C">Deep Freezer -80°C </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={3} >
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>Sample Freezer No*</InputLabel>
                                <Select
                                    label="Sample Freezer No"
                                    variant="outlined"
                                    className="input"
                                    fullWidth
                                    value={freezerNo || "none"}
                                    style={{ width: "100%", height: "40px" }}
                                    onChange={(e) => setFreezerNo(e.target.value)}
                                >
                                    <MenuItem value="none" disabled><em>Select Freezer No</em></MenuItem>
                                    <MenuItem value="1">Freezer 1</MenuItem>
                                    <MenuItem value="2">Freezer 2</MenuItem>
                                    <MenuItem value="3">Freezer 3</MenuItem>
                                    <MenuItem value="4">Freezer 4</MenuItem>
                                    <MenuItem value="5">Freezer 5</MenuItem>

                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <TextField
                                label="Rack No"
                                variant="outlined"
                                className="input"
                                type="number"
                                required
                                placeholder="Enter Rack No"
                                fullWidth
                                value={rack}
                                onChange={(e) => setRack(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <TextField
                                label="Box No"
                                variant="outlined"
                                className="input"
                                type="number"
                                required
                                placeholder="Enter Box No"
                                fullWidth
                                value={box}
                                onChange={(e) => setBox(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <TextField
                                label="Well No"
                                variant="outlined"
                                className="input"
                                type="number"
                                required
                                fullWidth
                                placeholder="Enter Well No"
                                value={wellId}
                                onChange={(e) => setWellId(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <TextField
                                label="Sample Handover To"
                                variant="outlined"
                                className="input"
                                required
                                placeholder="Enter Sample Handover Person Name"
                                fullWidth
                                value={handover}
                                onChange={(e) => sethandover(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <TextField
                                id="filled-number"
                                className="input"
                                label="Comment"
                                fullWidth
                                value={comment}
                                placeholder="type Comments"
                                variant="outlined"
                                onChange={(e) => setComment(e.target.value)}

                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <Button
                                color="primary"
                                variant="contained"
                                fullWidth
                                type="submit"
                                disabled={freezer === "" && freezerNo === ""}
                            >
                                {isEdit ? "Update" : "Add"}
                            </Button>
                        </Grid>
                    </Grid>
                    <div style={{ width: "100%" }}>
                        <TableContainer className={classes.tableContainer} component={Paper} style={{ maxHeight: "550px" }}>
                            <Table stickyHeader aria-label="simple table">
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell align="center">Sample Name</StyledTableCell>
                                        <StyledTableCell align="center">Freezer Name</StyledTableCell>
                                        <StyledTableCell align="center">Freezer No</StyledTableCell>
                                        <StyledTableCell align="center">Box No</StyledTableCell>
                                        <StyledTableCell align="center">Well No</StyledTableCell>
                                        <StyledTableCell align="center">Rack No</StyledTableCell>
                                        <StyledTableCell align="center">Sample Handover To</StyledTableCell>
                                        <StyledTableCell align="center">Comments</StyledTableCell>
                                        <StyledTableCell align="center">Edit</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {fetchSampleData?.map((data: any, index: any) => {
                                        return (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell align="center">{data?.name}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.storage?.freezerName}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.storage?.freezerNo}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.storage?.boxId}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.storage?.wellId}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.storage?.rackNo}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.storage?.handoverTo}</StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.storage?.comment === "" ? "" :
                                                        <div>
                                                            <MessageRounded
                                                                onClick={() => handleClick(data)}
                                                            />
                                                        </div>
                                                    }
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                    >
                                                        <Edit onClick={() => handleEdit(data)} />
                                                    </Button>
                                                </StyledTableCell>

                                            </StyledTableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>

                        </TableContainer>
                        <TicketCommentsModal
                            openModal={openModal}
                            setopenModal={setopenModal}
                            rundata={runData}
                        />
                    </div>
                </Paper>
            </form>
        </Grid >
    );
};
const mapStateToProps = (state: any) => ({
    projects: state.GenomicsLabReducer.projects,
    sapmleList: state.GenomicsLabReducer.sapmleList,
    sampleAllData: state.GenomicsLabReducer.sampleAllData,
    fetchsamplepdata: state.GenomicsLabReducer.fetchsamplepdata,
    loading: state.GenomicsLabReducer.loading,
});
export default connect(mapStateToProps, {
    getProjects,
    getProjectSampleList,
    getProjectSampleAllData,
    createSamplesStorage,
    getSampleProjectData,
    updateSamplesStorage,
})(StopsPlace);
